<template>
    <premade-comment :loadedPremadeComment="premadeComment" :update="false"></premade-comment>
</template>

<script>
    import _ from 'lodash'
    import PremadeComment from './components/PremadeComment.vue'
    export default {
        name: 'premade-sentences-add',
        components: {PremadeComment},
        data() {
            return {
                premadeComment: {premadeSentences :[], schools:[{id:3, name:'VIPKID'}], text: '', html: '', caption: '', favorite: 1, score:0},
            }
        },
        created(){
        },
        methods: {

        },
        watch: {

        }

    }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/premade-comments/Add.vue